// extracted by mini-css-extract-plugin
export default {"app":"PhoneOptionModal_app__UssZS","btns":"PhoneOptionModal_btns__Mxui7","close":"PhoneOptionModal_close__LnDO9"};